import { DatePipe, DecimalPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../../Services/Accounts/account.service';

@Component({
  selector: 'app-purchase',
  standalone: true,
  imports: [NgIf, NgFor, DecimalPipe],
  templateUrl: './purchase.component.html',
  styleUrl: './purchase.component.css'
})
export class PurchaseComponent implements OnChanges {
  @Input() firmId: any;
  @Input() isGst: boolean = true;
  @Input() fromDate: string = '';
  @Input() toDate: string = '';
  @Output() balancesLoaded = new EventEmitter<any[]>();

  isLoading = false;
  transactions: any[] = [];
  summary = {
    amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    opening_balance: 0,
    closing_balance: 0
  };

  purchaseSummary = {
    title: 'Purchase Details',
    total: 0,
  };

  // accordion
  accordionState = {
    purchase: false,
  };

  constructor(private accountService: AccountService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['firmId'] || changes['fromDate'] || changes['toDate']) {
      this.loadPurchaseData();
    }
  }

  loadPurchaseData() {
    this.isLoading = true;
    const params = {
      firm_id: this.firmId,
      from_date: this.fromDate,
      to_date: this.toDate
    };

    this.accountService.getDaybookCashflow(params).subscribe({
      next: (res: any) => {
        this.transactions = res.data.purchase_transactions || [];
        this.summary = res.data.summary;
        this.purchaseSummary.total = this.transactions.reduce((sum, t) => sum + Math.abs(t.total), 0);
        this.balancesLoaded.emit(res.data.account_balances || []);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading purchase data', err);
        this.isLoading = false;
      }
    });
  }

  toggleAccordion(type: 'purchase') {
    this.accordionState[type] = !this.accordionState[type];
  }

  getChips(trans: any) {
    return [
      { label: 'INV No.', value: trans.invoice_no },
      { label: 'Date', value: trans.date ? new Date(trans.date).toLocaleDateString('en-GB') : '' },
      { label: 'Firm', value: trans.firm },
      { label: 'Cash', value: trans.cash.toFixed(2) },
      { label: 'Bank', value: trans.bank?.toFixed(2) || '0.00' },
      { label: 'Card', value: trans.card?.toFixed(2) || '0.00' },
      { label: 'Online', value: trans.online?.toFixed(2) || '0.00' },
      { label: 'Disc', value: trans.disc?.toFixed(2) || '0.00' },
    ];
  }
}
